module.exports = __webpack_public_path__ + "img/3_james_d.db910549.png";